import { Map, List, fromJS } from 'immutable'
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from '@angular/core'

@Component({
  selector: 'form-preview-multiselect',
  templateUrl: './form-preview-multiselect.component.html',
  styleUrls: ['./form-preview-multiselect.component.css'],
})
export class FormPreviewMultiselectComponent implements OnInit, OnChanges {
  @Input('options') public options: List<Map<string, any>>
  @Input('value') public value: any
  @Input('row') public row: any
  @Output() onSelect: EventEmitter<any> = new EventEmitter()
  @Output() onInput: EventEmitter<any> = new EventEmitter()
  @Output() onGroupSelect: EventEmitter<any> = new EventEmitter()
  @Output() onGroupInput: EventEmitter<any> = new EventEmitter()
  @Output() onGroupSelectInput: EventEmitter<any> = new EventEmitter()

  @Input('values') public values: any
  @Input('activeForm') public activeForm: any

  public selected: Map<string, any> = fromJS({})

  constructor() {}

  ngOnInit() {}

  ngOnChanges() {
    if (this.value) {
      this.options.forEach((opt) => {
        if (this.keys().includes(opt.get('label'))) {
          const option = {
            index: opt.get('index'),
            label: opt.get('label'),
            value: this.value.get(opt.get('label')),
          }
          this.selected = this.selected.set(opt.get('index'), option)
        }
      })
    }
  }

  keys() {
    return this.value ? this.value.keySeq().toArray() : []
  }

  handleFieldChange(e: any, index: any, label: string) {
    if (e.target.type === 'checkbox') {
      if (e.target.checked) {
        if (this.value !== undefined) {
          const label = this.options
            .filter((o) => o.get('index') == index)
            .getIn([0, 'label'])
          this.selected = this.selected.set(index, {
            value: '',
            index,
            label,
          })
        } else {
          const option = this.options
            .filter((o) => o.get('index') == index)
            .get(0)

          this.selected = this.selected.set(index, {
            index: option.get('index'),
            label: option.get('label'),
            value: this.value?.get(option.get('label')) ?? '',
          })
        }
      } else {
        this.selected = this.selected.delete(index)
      }
      this.onSelect.emit(fromJS(this.selected.valueSeq().toArray()))
    } else {
      this.selected = this.selected.setIn(
        [index, e.target.name],
        parseFloat(e.target.value),
      )
      this.onInput.emit({
        index,
        label: label,
        value: parseFloat(e.target.value),
      })
    }
  }

  showChildren(row: any, option: any) {
    if (row.get('isMultiple')) {
      if (Map.isMap(this.selected)) {
        const selected = this.selected.valueSeq().toArray()
        return !!selected.find(({ label }) => label === option.get('label'))
      }

      if (this.value) {
        if (Map.isMap(this.value)) {
          if (this.value.get(option.get('label')) !== undefined) return true
        }

        if (Array.isArray(this.value)) {
          if (this.value.includes(option.get('label'))) return true
        }
      }
    } else {
      if (this[row.get('name')]) {
        if (this[row.get('name')].equals(option)) return true
      }
      if (option.get('label') === this.value) return true
    }

    return false
  }
}
